import { render } from "./JobStateChip.vue?vue&type=template&id=72862bff&scoped=true"
import script from "./JobStateChip.vue?vue&type=script&lang=js"
export * from "./JobStateChip.vue?vue&type=script&lang=js"

import "./JobStateChip.vue?vue&type=style&index=0&id=72862bff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72862bff"]])

export default __exports__